import s from 'styled-components';
import SectHeader from "_c/modules/profile/common/SectHeader";
import Info from "_c/atoms/Info";

export const Wrap = s.section`
  margin: 0 12px;
  margin-bottom: 30px;
`;
export const Head = s(SectHeader)`
  text-align: left;
`
export const Placeholder = s(Info)`
  display: inline-block;
  margin: 0;
`